import axios from "axios";
import Vue from "vue";
import {Loading, Message} from "element-ui";

let config = {
  managerHost: "",
  // oaHost: "https://admin.xianqianxin.com/api/qx-oos-web-srv"
  oaHost: "/api/qx-oos-web-srv"
  // oaHost: "http://oostest.xianqianxin.com/qx-oos-web-srv" //测试 外网IP
  // oaHost: "https://oos.xianqianxin.com/qx-oos-web-srv" //正式
  // H5单独的域名
  // H5Host: "http://apptest.xianqianxin.com/" //测试
  // H5Host: "https://app.xianqianxin.com/" //正式
};

function bizCode(payload) {
  if (!payload) return "";
  if (payload.code != null && payload.code !== "") return String(payload.code);
  if (payload.HEAD && payload.HEAD.CODE != null) return String(payload.HEAD.CODE);
  return "";
}
function bizMsg(payload) {
  if (!payload) return "";
  if (payload.msg != null && payload.msg !== "") return payload.msg;
  if (payload.HEAD && payload.HEAD.MSG != null) return payload.HEAD.MSG;
  return "";
}
function normalizeBiz(payload) {
  if (!payload || payload.HEAD) return payload;
  if (payload.code == null) return payload;
  let body = payload.data;
  if (Array.isArray(body)) {
    body = { res: body };
  } else if (body && typeof body === "object" && body.token && !body.TOKEN) {
    body = Object.assign({}, body, { TOKEN: body.token });
  }
  return Object.assign({}, payload, {
    HEAD: { CODE: payload.code, MSG: payload.msg },
    BODY: body
  });
}
const apiUrl = {
  // ai记录
  FACEAUTHWHITElist: {
    type: "post",
    url: config.managerHost + "/api/face-auth-white/page",
    ContentType: "application/json"
  },
  // ai加白
  FACEAUTHWHITEwhite: {
    type: "post",
    url: config.managerHost + "/api/face-auth-white/create",
    ContentType: "application/json"
  },
  // ai列表类型
  FACEAUTHWHITEtype: {
    type: "post",
    url: config.managerHost + "/api/face-auth-white/types",
    ContentType: "application/json"
  },
  // 冻结记录
  FROZENUSERRECODE: {
    type: "post",
    url: config.managerHost + "/api/users/frozen-records/page",
    ContentType: "application/json"
  },
  // 用户冻结记录处理类型列表
  FROZENUSERRECODE06: {
    type: "post",
    url: config.managerHost + "/api/users/frozen-records/handle-types",
    ContentType: "application/json"
  },
  // 用户冻结记录风险类型列表
  FROZENUSERRECODE07: {
    type: "post",
    url: config.managerHost + "/api/users/frozen-records/risk-types",
    ContentType: "application/json"
  },
  // 冻结权限--新列表
  USERWALLETPERMISSIONS: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/page",
    ContentType: "application/json"
  },
  // 冻结权限--新保存---冻结
  saveUSERWALLETPERMISSIONS: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/freeze",
    ContentType: "application/json"
  },
  // 冻结权限--新编辑---解冻
  editUSERWALLETPERMISSIONS: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/unfreeze",
    ContentType: "application/json"
  },
  // 冻结权限--获取权限
  getUSERWALLETPERMISSIONS: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/types",
    ContentType: "application/json"
  },
  // 用户手机号修改记录分页查询
  usermobileedit: {
    type: "post",
    url: config.managerHost + "/api/mobile-changes/page",
    ContentType: "application/json"
  },
  // 用户手机号修改记录---作废
  usermobilezf: {
    type: "post",
    url: config.managerHost + "/api/mobile-changes/update",
    ContentType: "application/json"
  },
  // 官网文章分页 OFFICIAL_WEBSITE_002
  OFFICIALWEBSITE: {
    type: "post",
    url: config.managerHost + "/api/website/articles/page",
    ContentType: "application/json"
  },
  // 官网文章新增/编辑/撤销 OFFICIAL_WEBSITE_003
  OFFICIALWEBSITEadd: {
    type: "post",
    url: config.managerHost + "/api/website/articles/save",
    ContentType: "application/json"
  },
  // 官网栏目列表 OFFICIAL_WEBSITE_011（BODY.rows）
  OFFICIALtype: {
    type: "post",
    url: config.managerHost + "/api/website/article-types",
    ContentType: "application/json"
  },
  // 用户文件全量 ALI_OSS_FILE_002
  fileslist: {
    type: "post",
    url: config.managerHost + "/api/oss-files/list",
    ContentType: "application/json"
  },
  // 用户文件分页 ALI_OSS_FILE_001
  fileslistFILE: {
    type: "post",
    url: config.managerHost + "/api/oss-files/page",
    ContentType: "application/json"
  },
  //用户提现申请列表
  WITHDRAWREVIEWlist: {
    type: "post",
    url: config.managerHost + "/api/withdraws/reviews/page",
    ContentType: "application/json"
  },
  //用户钱包冻结
  FREEZEUSERAUTH001: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/freeze",
    ContentType: "application/json"
  },
  // H5单独的---获取封禁用户
  H5getFrozenList: {
    type: "post",
    url: config.managerHost + "/api/users/h5-frozen",
    ContentType: "application/json"
  },
  // 提现权限冻结
  updateuserauth: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/update",
    ContentType: "application/json"
  },
  // 充值权限冻结
  RECHARGEuserauth: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/update",
    ContentType: "application/json"
  },
  // 转账权限冻结
  TRANSFERuserauth: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/update",
    ContentType: "application/json"
  },
  // 权限冻结---列表
  listuserauth: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/page",
    ContentType: "application/json"
  },
  // 权限冻结---新列表
  listuserauthnew: {
    type: "post",
    url: config.managerHost + "/api/wallet-permissions/freeze",
    ContentType: "application/json"
  },
  //管理员列表
  glyListResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/page",
    ContentType: "application/json"
  },
  //管理员导出
  yhExportResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/export",
    ContentType: "application/json"
  },
  //查询风险用户
  getRiskUser: {
    type: "post",
    url: config.managerHost + "/api/risk-users/page",
    ContentType: "application/json"
  },
  //添加风险用户
  addRiskUser: {
    type: "post",
    url: config.managerHost + "/api/risk-users/save",
    ContentType: "application/json"
  },
  //风控核查案例列表
  riskCaseList: {
    type: "post",
    url: config.managerHost + "/api/risk-cases/page",
    ContentType: "application/json"
  },
  //风控核查案例处置
  riskCaseProcess: {
    type: "post",
    url: config.managerHost + "/api/risk-cases/process",
    ContentType: "application/json"
  },
  // 仅结束风控核查案例，不重复执行用户处置
  riskCaseComplete: {
    type: "post",
    url: config.managerHost + "/api/risk-cases/complete",
    ContentType: "application/json"
  },
  // 风控核查用户好友列表
  riskCaseFriendList: {
    type: "post",
    url: config.managerHost + "/api/risk-cases/friends",
    ContentType: "application/json"
  },

  // 开票审核-提现记录 一键代发
  onekeyHandleResource: {
    type: "post",
    url: config.managerHost + "/api/risk-cases/complete",
    ContentType: "application/json"
  },
  //登录
  loginResource: {
    type: "post",
    url: config.managerHost + "/api/auth/login",
    ContentType: "application/json"
  },
  //获取短信验证码
  verificationCode: {
    type: "post",
    url: config.managerHost + "/api/sms/send",
    ContentType: "application/json"
  },
  //系统配置列表
  sysListResource: {
    type: "post",
    url: config.managerHost + "/api/config/page",
    ContentType: "application/json"
  },
  //系统配置修改
  xgsysResource: {
    type: "post",
    url: config.managerHost + "/api/config/update",
    ContentType: "application/json"
  },
  // app首屏列表
  firstimageList: {
    type: "post",
    url: config.managerHost + "/api/ads/app/page",
    ContentType: "application/json"
  },
  // app首屏列表----上传
  firstimageUpload: {
    type: "post",
    url: config.managerHost + "/api/ads/app/update",
    ContentType: "application/json"
  },
  // pc首屏列表
  pcfirstimageList: {
    type: "post",
    url: config.managerHost + "/api/ads/pc/page",
    ContentType: "application/json"
  },
  // pc首屏列表----上传
  pcfirstimageUpload: {
    type: "post",
    url: config.managerHost + "/api/ads/pc/update",
    ContentType: "application/json"
  },

  //管理员列表
  FileSystemDirectoryEntryimage: {
    type: "post",
    url: config.managerHost + "/api/system/admins/page",
    ContentType: "application/json"
  },
  //重置密码
  czPassResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/reset-password",
    ContentType: "application/json"
  },
  //添加管理员
  addSysResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/create",
    ContentType: "application/json"
  },
  //修改管理员姓名
  changeSysResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/rename",
    ContentType: "application/json"
  },
  //删除管理员
  deleteSysResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/delete",
    ContentType: "application/json"
  },
  //退出登录
  logoutResource: {
    type: "post",
    url: config.managerHost + "/api/auth/logout",
    ContentType: "application/json"
  },
  //获取当前登陆用户信息
  getUserResource: {
    type: "post",
    url: config.managerHost + "/api/auth/current",
    ContentType: "application/json"
  },
  //修改密码
  xgPasswordResource: {
    type: "post",
    url: config.managerHost + "/api/auth/password",
    ContentType: "application/json"
  },
  //管理员锁定/解除锁定
  xgstatusResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/state",
    ContentType: "application/json"
  },
  //短信记录
  ckmessageResource: {
    type: "post",
    url: config.managerHost + "/api/sms/page",
    ContentType: "application/json"
  },
  //添加银行支行
  addbankResource: {
    type: "post",
    url: config.managerHost + "/api/banks/branch/create",
    ContentType: "application/json"
  },
  //标记短信状态
  statusMessageResource: {
    type: "post",
    url: config.managerHost + "/api/sms/flag",
    ContentType: "application/json"
  },
  //菜单添加
  addMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/menus/create",
    ContentType: "application/json"
  },
  //菜单管理列表
  getOneMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/menus/top",
    ContentType: "application/json"
  },
  //菜单管理列表(根据父类id查询)
  getOTherMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/menus/children",
    ContentType: "application/json"
  },
  //菜单修改
  modifyMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/menus/update",
    ContentType: "application/json"
  },
  //角色管理列表
  roleMangementResource: {
    type: "post",
    url: config.managerHost + "/api/system/roles/page",
    ContentType: "application/json"
  },
  //角色添加
  roleAddResource: {
    type: "post",
    url: config.managerHost + "/api/system/roles/create",
    ContentType: "application/json"
  },
  //角色修改
  roleUpdateResource: {
    type: "post",
    url: config.managerHost + "/api/system/roles/update",
    ContentType: "application/json"
  },
  //查看所有菜单（树状结构）
  cxALLMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/menus/tree",
    ContentType: "application/json"
  },
  //根据角色查看该角色分配过的的所有菜单
  cxroleIddMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/menus/by-role",
    ContentType: "application/json"
  },
  //角色分配菜单
  fpdMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/roles/assign-menus",
    ContentType: "application/json"
  },
  //角色删除
  scRoleResource: {
    type: "post",
    url: config.managerHost + "/api/system/roles/delete",
    ContentType: "application/json"
  },
  //删除菜单
  scMenuResource: {
    type: "post",
    url: config.managerHost + "/api/system/menus/delete",
    ContentType: "application/json"
  },
  //查看所有角色
  ckRoleResource: {
    type: "post",
    url: config.managerHost + "/api/system/roles/enabled",
    ContentType: "application/json"
  },
  //查看用户角色
  ckUserRoleResource: {
    type: "post",
    url: config.managerHost + "/api/system/roles/by-admin",
    ContentType: "application/json"
  },
  //管理员分配角色
  adMinisFpRoleResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/assign-roles",
    ContentType: "application/json"
  },
  //操作记录列表查询
  ckOperationRecordResource: {
    type: "post",
    url: config.managerHost + "/api/oplog/history/page",
    ContentType: "application/json"
  },
  //操作记录配置列表
  operationLogConfigList: {
    type: "post",
    url: config.managerHost + "/api/oplog/config/page",
    ContentType: "application/json"
  },
  //新增操作记录配置
  operationLogConfigAdd: {
    type: "post",
    url: config.managerHost + "/api/oplog/config/create",
    ContentType: "application/json"
  },
  //删除操作记录配置
  operationLogConfigDelete: {
    type: "post",
    url: config.managerHost + "/api/oplog/config/delete",
    ContentType: "application/json"
  },
  //启用/停用操作记录配置
  operationLogConfigToggle: {
    type: "post",
    url: config.managerHost + "/api/oplog/config/state",
    ContentType: "application/json"
  },
  //查询所有管理员
  ckAllManangeResource: {
    type: "post",
    url: config.managerHost + "/api/system/admins/all",
    ContentType: "application/json"
  },
  //上传Banner图
  upImagesResource: {
    type: "post",
    url: config.managerHost + "/api/upload/banner",
    ContentType: "multipart/form-data"
  },
  //上传图片/JOB_010
  xgPictureResource: {
    type: "post",
    url: config.managerHost + "/api/upload/image",
    ContentType: "multipart/form-data"
  },
  //修改状态/POS_022
  xgstateResource: {
    type: "post",
    url: config.managerHost + "/api/upload/state",
    ContentType: "application/json"
  },
  // 首页报表 - 交易
  getHomeReport: {
    type: "post",
    url: config.managerHost + "/api/home/charts",
    ContentType: "application/json"
  },
  // 首页报表 - 汇总
  getHomeReportSum: {
    type: "post",
    url: config.managerHost + "/api/home/summary",
    ContentType: "application/json"
  },
  // 敏感词汇管理 - 列表
  getSensitiveWordList: {
    type: "post",
    url: config.managerHost + "/api/audit/admin/words/page",
    ContentType: "application/json"
  },
  // 敏感词汇管理 - 添加
  addSensitiveWord: {
    type: "post",
    url: config.managerHost + "/api/audit/admin/words/add",
    ContentType: "application/json"
  },
  // 敏感词汇管理 - 删除
  delSensitiveWord: {
    type: "post",
    url: config.managerHost + "/api/audit/admin/words/delete",
    ContentType: "application/json"
  },
  // 云端审核 - 配置列表
  auditCfgList: {
    type: "post",
    url: config.managerHost + "/api/audit/configs/page",
    ContentType: "application/json"
  },
  auditCfgDetail: {
    type: "post",
    url: config.managerHost + "/api/audit/configs/detail",
    ContentType: "application/json"
  },
  auditCfgSave: {
    type: "post",
    url: config.managerHost + "/api/audit/configs/save",
    ContentType: "application/json"
  },
  auditCfgDelete: {
    type: "post",
    url: config.managerHost + "/api/audit/configs/delete",
    ContentType: "application/json"
  },
  auditCfgSetDefault: {
    type: "post",
    url: config.managerHost + "/api/audit/configs/set-default",
    ContentType: "application/json"
  },
  auditCfgBindLibs: {
    type: "post",
    url: config.managerHost + "/api/audit/configs/bind-libs",
    ContentType: "application/json"
  },
  auditLibList: {
    type: "post",
    url: config.managerHost + "/api/audit/libs/page",
    ContentType: "application/json"
  },
  auditLibSync: {
    type: "post",
    url: config.managerHost + "/api/audit/libs/sync",
    ContentType: "application/json"
  },
  auditLibSave: {
    type: "post",
    url: config.managerHost + "/api/audit/libs/save",
    ContentType: "application/json"
  },
  auditLibDelete: {
    type: "post",
    url: config.managerHost + "/api/audit/libs/delete",
    ContentType: "application/json"
  },
  auditWordList: {
    type: "post",
    url: config.managerHost + "/api/audit/words/page",
    ContentType: "application/json"
  },
  auditWordAdd: {
    type: "post",
    url: config.managerHost + "/api/audit/words/add",
    ContentType: "application/json"
  },
  auditWordDelete: {
    type: "post",
    url: config.managerHost + "/api/audit/words/delete",
    ContentType: "application/json"
  },
  // 用户管理/会员管理 - 列表（ImUserAction，yw_imuser_account + 腾讯IM头像/性别补全）
  getUserList: {
    type: "post",
    url: config.managerHost + "/api/users/page",
    ContentType: "application/json"
  },
  userFriendList: {
    type: "post",
    url: config.managerHost + "/api/users/friends",
    ContentType: "application/json"
  },
  userJoinedGroupList: {
    type: "post",
    url: config.managerHost + "/api/users/joined-groups",
    ContentType: "application/json"
  },

  // 用户管理--处理--永久冻结查询
  gochecks: {
    type: "post",
    url: config.managerHost + "/api/reports/sn",
    ContentType: "application/json"
  },
  // 会员管理 ---修改会员时间
  updateVipRTime: {
    type: "post",
    url: config.managerHost + "/api/users/vip-time",
    ContentType: "application/json"
  },
  // 用户管理 - 冻结
  frozenUser: {
    type: "post",
    url: config.managerHost + "/api/users/freeze",
    ContentType: "application/json"
  },
  // 用户管理 - 解冻
  thawUser: {
    type: "post",
    url: config.managerHost + "/api/users/unfreeze",
    ContentType: "application/json"
  },
  // 用户管理---刷新缓存
  aclear: {
    type: "post",
    url: config.managerHost + "/api/users/refresh-cache",
    ContentType: "application/json"
  },

  // 用户管理 - 冻结列表
  getFrozenList: {
    type: "post",
    url: config.managerHost + "/api/users/frozen-list",
    ContentType: "application/json"
  },
  // 用户列表---聊天记录查询（已迁移至云端内容审核按会话查询）
  messageList: {
    type: "post",
    url: config.managerHost + "/api/content-audit/sessions",
    ContentType: "application/json"
  },
  // 用户列表----聊天记录导出
  MessageExports: {
    type: "post",
    url: config.managerHost + "/api/messages/export",
    ContentType: "application/json",
    responseType: "blob"
  },

  // 用户管理 - 修改
  updateUser: {
    type: "post",
    url: config.managerHost + "/api/users/update",
    ContentType: "application/json"
  },
  // 经营类目列表
  YWLABELlist: {
    type: "post",
    url: config.managerHost + "/api/labels/list",
    ContentType: "application/json"
  },
  // 用户列表-冻结--导出
  DJExports: {
    type: "post",
    url: config.managerHost + "/api/users/frozen-export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 用户列表---导出
  UserListExports: {
    type: "post",
    url: config.managerHost + "/api/users/export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 用户管理 - 上传头像
  uploadPortrait: {
    type: "post",
    url: config.managerHost + "/api/users/portrait",
    ContentType: "multipart/form-data"
  },
  // 用户管理 - 内部余额
  inBalance: {
    type: "post",
    url: config.managerHost + "/api/users/balance/in",
    ContentType: "application/json"
  },
  // 用户管理 - 外部余额
  outBalance: {
    type: "post",
    url: config.managerHost + "/api/users/balance/out",
    ContentType: "application/json"
  },
  // 用户管理 - 费率变更
  rateUpdate: {
    type: "post",
    url: config.managerHost + "/api/users/fee/update",
    ContentType: "application/json"
  },
  // 用户管理 - 费率查询
  getRate: {
    type: "post",
    url: config.managerHost + "/api/users/fee/get",
    ContentType: "application/json"
  },
  // 用户管理 - 实名信息 - 实名信息查询
  getRealNameInfo: {
    type: "post",
    url: config.managerHost + "/api/users/real-name",
    ContentType: "application/json"
  },
  // 用户管理 - 用户列表 - 额度变更
  quotaChange: {
    type: "post",
    url: config.managerHost + "/api/users/quota/update",
    ContentType: "application/json"
  },
  // 用户管理 - 用户列表 - 查询用户转账额度
  selectQuotaChange: {
    type: "post",
    url: config.managerHost + "/api/users/quota/get",
    ContentType: "application/json"
  },
  // 群组管理 - 列表
  getGroupList: {
    type: "post",
    url: config.managerHost + "/api/groups/page",
    ContentType: "application/json"
  },
  // 群组管理 - 冻结群
  frozenGroup: {
    type: "post",
    url: config.managerHost + "/api/groups/freeze",
    ContentType: "application/json"
  },
  // 群组管理 - 解冻群
  thawGroup: {
    type: "post",
    url: config.managerHost + "/api/groups/unfreeze",
    ContentType: "application/json"
  },
  // 群组管理 - 群冻结列表
  getGroupFrozenList: {
    type: "post",
    url: config.managerHost + "/api/groups/frozen-records/page",
    ContentType: "application/json"
  },
  // 群组管理 - 群成员列表
  getGroupMemberList: {
    type: "post",
    url: config.managerHost + "/api/groups/members/page",
    ContentType: "application/json"
  },
  // 投诉管理》用户/群 - 查询
  getComplaintList: {
    type: "post",
    url: config.managerHost + "/api/reports/page",
    ContentType: "application/json"
  },
  // 投诉管理》用户/群 - 处理投诉
  complaintHandling: {
    type: "post",
    url: config.managerHost + "/api/reports/handle",
    ContentType: "application/json"
  },
  // 消息管理用户 - 查询
  getFXMessageList: {
    type: "post",
    url: config.managerHost + "/api/messages/dialogue/page",
    ContentType: "application/json"
  },
  // 风险消息管理用户 - 查询
  getMessageList: {
    type: "post",
    url: config.managerHost + "/api/messages/c2c/page",
    ContentType: "application/json"
  },
  // 消息管理群 - 查询
  getGroupMessageList: {
    type: "post",
    url: config.managerHost + "/api/messages/group/page",
    ContentType: "application/json"
  },
  // 云端内容审核 - 记录列表
  contentAuditList: {
    type: "post",
    url: config.managerHost + "/api/content-audit/page",
    ContentType: "application/json"
  },
  // 云端内容审核 - 按会话查询
  contentAuditByConv: {
    type: "post",
    url: config.managerHost + "/api/content-audit/sessions",
    ContentType: "application/json"
  },
  // 云端内容审核 - 拦截记录列表
  contentAuditBlocked: {
    type: "post",
    url: config.managerHost + "/api/content-audit/intercepts",
    ContentType: "application/json"
  },
  // 云端内容审核 - 后台处理
  contentAuditHandle: {
    type: "post",
    url: config.managerHost + "/api/content-audit/handle",
    ContentType: "application/json"
  },
  // 云端内容审核 - 按审核记录 ID 批量撤回（自动区分单聊/群聊）
  contentAuditRecallByIds: {
    type: "post",
    url: config.managerHost + "/api/content-audit/recall",
    ContentType: "application/json"
  },
  // 云端内容审核 - 按用户 ID 查询聊天记录（投诉等场景）
  contentAuditByUserIds: {
    type: "post",
    url: config.managerHost + "/api/content-audit/c2c",
    ContentType: "application/json"
  },
  // 客户聊天审查 - 按用户拉会话
  chatReviewConversations: {
    type: "post",
    url: config.managerHost + "/api/content-audit/review",
    ContentType: "application/json"
  },
  chatReviewExport: {
    type: "post",
    url: config.managerHost + "/api/content-audit/review/export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 圈子管理 - 列表
  circleList: {
    type: "post",
    url: config.managerHost + "/api/circles/page",
    ContentType: "application/json"
  },
  // 圈子管理 - 详情
  circleDetail: {
    type: "post",
    url: config.managerHost + "/api/circles/detail",
    ContentType: "application/json"
  },
  // 圈子管理 - 修改
  circleUpdate: {
    type: "post",
    url: config.managerHost + "/api/circles/update",
    ContentType: "application/json"
  },
  // 圈子管理 - 冻结
  circleFreeze: {
    type: "post",
    url: config.managerHost + "/api/circles/freeze",
    ContentType: "application/json"
  },
  // 圈子管理 - 解冻
  circleUnfreeze: {
    type: "post",
    url: config.managerHost + "/api/circles/unfreeze",
    ContentType: "application/json"
  },
  // 圈子管理 - 解散
  circleDissolve: {
    type: "post",
    url: config.managerHost + "/api/circles/dissolve",
    ContentType: "application/json"
  },
  // 圈子管理 - 成员列表
  circleMemberList: {
    type: "post",
    url: config.managerHost + "/api/circles/members/page",
    ContentType: "application/json"
  },
  // 圈子管理 - 封禁成员
  circleMemberBan: {
    type: "post",
    url: config.managerHost + "/api/circles/members/ban",
    ContentType: "application/json"
  },
  // 圈子管理 - 解封成员
  circleMemberUnban: {
    type: "post",
    url: config.managerHost + "/api/circles/members/unban",
    ContentType: "application/json"
  },
  // 圈子管理 - 转让圈主
  circleTransferOwner: {
    type: "post",
    url: config.managerHost + "/api/circles/transfer-owner",
    ContentType: "application/json"
  },
  // 圈子管理 - 频道列表
  circleChannelList: {
    type: "post",
    url: config.managerHost + "/api/circles/channels/list",
    ContentType: "application/json"
  },
  // 圈子管理 - 群/话题消息漫游
  circleGroupMsg: {
    type: "post",
    url: config.managerHost + "/api/circles/messages/roam",
    ContentType: "application/json"
  },
  // 圈子管理 - 圈主内容审核
  circleOwnerAuditList: {
    type: "post",
    url: config.managerHost + "/api/circles/audit/owner-page",
    ContentType: "application/json"
  },
  // 圈子管理 - 同步 IM 群成员到本地（成功后请调 CIRCLE_007 刷新列表）
  circleSyncImMembers: {
    type: "post",
    url: config.managerHost + "/api/circles/sync/members",
    ContentType: "application/json"
  },
  // 圈子管理 - 移除成员
  circleMemberKick: {
    type: "post",
    url: config.managerHost + "/api/circles/members/kick",
    ContentType: "application/json"
  },
  // 圈子管理 - 同步 IM 群资料
  circleSyncIm: {
    type: "post",
    url: config.managerHost + "/api/circles/sync/info",
    ContentType: "application/json"
  },
  // 圈子管理 - 全部群聊审核
  circleGroupAuditList: {
    type: "post",
    url: config.managerHost + "/api/circles/audit/group-page",
    ContentType: "application/json"
  },
  // 圈子管理 - 处理审核记录
  circleAuditHandle: {
    type: "post",
    url: config.managerHost + "/api/circles/audit/handle",
    ContentType: "application/json"
  },
  // 圈子管理 - 撤回审核消息
  circleAuditRecall: {
    type: "post",
    url: config.managerHost + "/api/circles/audit/recall",
    ContentType: "application/json"
  },
  circlePostList: {
    type: "post",
    url: config.managerHost + "/api/circles/posts/page",
    ContentType: "application/json"
  },
  circlePostReview: {
    type: "post",
    url: config.managerHost + "/api/circles/posts/review",
    ContentType: "application/json"
  },
  circlePostDelete: {
    type: "post",
    url: config.managerHost + "/api/circles/posts/delete",
    ContentType: "application/json"
  },
  // 仟信豆提现 - 列表
  beanWithdrawList: {
    type: "post",
    url: config.managerHost + "/api/bean-withdraws/page",
    ContentType: "application/json"
  },
  // 仟信豆提现 - 详情
  beanWithdrawDetail: {
    type: "post",
    url: config.managerHost + "/api/bean-withdraws/detail",
    ContentType: "application/json"
  },
  // 仟信豆提现 - 个税试算
  beanWithdrawTaxPreview: {
    type: "post",
    url: config.managerHost + "/api/bean-withdraws/tax-preview",
    ContentType: "application/json"
  },
  // 仟信豆提现 - 审核拒绝
  beanWithdrawReject: {
    type: "post",
    url: config.managerHost + "/api/bean-withdraws/reject",
    ContentType: "application/json"
  },
  // 仟信豆提现 - 审核通过并打款
  beanWithdrawApprove: {
    type: "post",
    url: config.managerHost + "/api/bean-withdraws/approve",
    ContentType: "application/json"
  },
  // 用户视频认证 - 列表
  userVerifyVideoList: {
    type: "post",
    url: config.managerHost + "/api/verify-videos/page",
    ContentType: "application/json"
  },
  // 用户视频认证 - 详情
  userVerifyVideoDetail: {
    type: "post",
    url: config.managerHost + "/api/verify-videos/detail",
    ContentType: "application/json"
  },
  // 用户视频认证 - 历史
  userVerifyVideoHistory: {
    type: "post",
    url: config.managerHost + "/api/verify-videos/history",
    ContentType: "application/json"
  },
  // 用户视频认证 - 审核
  userVerifyVideoReview: {
    type: "post",
    url: config.managerHost + "/api/verify-videos/review",
    ContentType: "application/json"
  },
  // 订单管理 - 靓号购买订单列表
  prettyOrderList: {
    type: "post",
    url: config.managerHost + "/api/orders/pretty/page",
    ContentType: "application/json"
  },
  // 订单管理 - 靓号购买订单详情
  prettyOrderDetail: {
    type: "post",
    url: config.managerHost + "/api/orders/pretty/detail",
    ContentType: "application/json"
  },
  // 订单管理 - 会员购买订单列表
  vipOrderList: {
    type: "post",
    url: config.managerHost + "/api/orders/vip/page",
    ContentType: "application/json"
  },
  // 订单管理 - 会员购买订单详情
  vipOrderDetail: {
    type: "post",
    url: config.managerHost + "/api/orders/vip/detail",
    ContentType: "application/json"
  },
  // 订单管理 - 仟信币购买订单列表
  coinOrderList: {
    type: "post",
    url: config.managerHost + "/api/orders/coin/page",
    ContentType: "application/json"
  },
  // 订单管理 - 仟信币购买订单详情
  coinOrderDetail: {
    type: "post",
    url: config.managerHost + "/api/orders/coin/detail",
    ContentType: "application/json"
  },
  // 钱包风控 - 场景列表 RISK_CFG_001
  walletRiskSceneList: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/scenes",
    ContentType: "application/json"
  },
  // 钱包风控 - 场景开关 RISK_CFG_002
  walletRiskSceneToggle: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/scenes/toggle",
    ContentType: "application/json"
  },
  // 钱包风控 - 规则分页 RISK_CFG_003
  walletRiskRulePage: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/rules/page",
    ContentType: "application/json"
  },
  // 钱包风控 - 修改规则 RISK_CFG_004
  walletRiskRuleUpdate: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/rules/update",
    ContentType: "application/json"
  },
  // 钱包风控 - 规则参数列表 RISK_CFG_005
  walletRiskRuleParamList: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/rule-params",
    ContentType: "application/json"
  },
  // 钱包风控 - 修改规则参数 RISK_CFG_006
  walletRiskRuleParamUpdate: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/rule-params/update",
    ContentType: "application/json"
  },
  // 钱包风控 - 全局参数列表 RISK_CFG_007
  walletRiskGlobalParamList: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/global-params",
    ContentType: "application/json"
  },
  // 钱包风控 - 修改全局参数 RISK_CFG_008
  walletRiskGlobalParamUpdate: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/global-params/update",
    ContentType: "application/json"
  },
  // 钱包风控 - 账户等级列表 RISK_CFG_009
  walletRiskAccountLevelList: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/account-levels",
    ContentType: "application/json"
  },
  // 钱包风控 - 修改账户等级 RISK_CFG_010
  walletRiskAccountLevelUpdate: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/account-levels/update",
    ContentType: "application/json"
  },
  // 钱包风控 - 用户限额分页 RISK_CFG_011
  walletRiskUserLimitPage: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/user-limits/page",
    ContentType: "application/json"
  },
  // 钱包风控 - 保存用户限额 RISK_CFG_012
  walletRiskUserLimitSave: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/user-limits/save",
    ContentType: "application/json"
  },
  // 钱包风控 - 校验主日志 RISK_CFG_013
  walletRiskCheckLogPage: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/check-logs/page",
    ContentType: "application/json"
  },
  // 钱包风控 - 命中明细 RISK_CFG_014
  walletRiskHitLogList: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/hit-logs",
    ContentType: "application/json"
  },
  // 钱包风控 - 配置审计 RISK_CFG_015
  walletRiskConfigLogPage: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/config-logs/page",
    ContentType: "application/json"
  },
  // 钱包风控 - 强制刷新 RISK_CFG_016（只写审计，不触发引擎 reload）
  walletRiskForceRefresh: {
    type: "post",
    url: config.managerHost + "/api/wallet-risk/force-refresh",
    ContentType: "application/json"
  },
  // 消息管理》广播消息 - 广播
  broadcastMessage: {
    type: "post",
    url: config.managerHost + "/api/messages/broadcast",
    ContentType: "application/json"
  },
  // 消息管理》群发消息（腾讯 IM batchsendmsg：content, userIds[], title, notifyType）
  massMessage: {
    type: "post",
    url: config.managerHost + "/api/messages/mass",
    ContentType: "application/json"
  },
  // APP版本管理 - 添加
  addVersion: {
    type: "post",
    url: config.managerHost + "/api/version/create",
    ContentType: "application/json"
  },
  // APP版本管理 - 修改
  updVersion: {
    type: "post",
    url: config.managerHost + "/api/version/update",
    ContentType: "application/json"
  },
  // APP版本管理 - 查询
  getVersionList: {
    type: "post",
    url: config.managerHost + "/api/version/page",
    ContentType: "application/json"
  },
  // 系统参数管理 - 添加
  addSystemParam: {
    type: "post",
    url: config.managerHost + "/api/config/create",
    ContentType: "application/json"
  },
  // 系统参数管理 - 修改
  updSystemParam: {
    type: "post",
    url: config.managerHost + "/api/config/update",
    ContentType: "application/json"
  },
  // 系统参数管理 - 查询
  getSystemParamList: {
    type: "post",
    url: config.managerHost + "/api/config/page",
    ContentType: "application/json"
  },
  // 系统参数管理 - 按 code 查单条
  getSystemParamByCode: {
    type: "post",
    url: config.managerHost + "/api/config/by-code",
    ContentType: "application/json"
  },
  // 系统设置 - 白名单管理 - 查询
  getWhiteParamList: {
    type: "post",
    url: config.managerHost + "/api/whitelist/page",
    ContentType: "application/json"
  },
  // 系统设置 - 白名单管理 - 添加
  addWhiteParam: {
    type: "post",
    url: config.managerHost + "/api/whitelist/create",
    ContentType: "application/json"
  },
  // 系统设置 - 白名单管理 - 修改
  updWhiteParam: {
    type: "post",
    url: config.managerHost + "/api/whitelist/update",
    ContentType: "application/json"
  },
  // 靓号管理》靓号类型管理 - 查询
  getLianghaoTypeList: {
    type: "post",
    url: config.managerHost + "/api/pretty/type/page",
    ContentType: "application/json"
  },
  // 靓号管理》靓号类型管理 - 添加
  addLianghaoType: {
    type: "post",
    url: config.managerHost + "/api/pretty/type/create",
    ContentType: "application/json"
  },
  // 靓号管理》靓号类型管理 - 修改
  updLianghaoType: {
    type: "post",
    url: config.managerHost + "/api/pretty/type/update",
    ContentType: "application/json"
  },
  // 靓号管理》靓号管理 - 查询
  getLianghaoList: {
    type: "post",
    url: config.managerHost + "/api/pretty/phone/page",
    ContentType: "application/json"
  },
  // 靓号管理》靓号管理 - 修改
  updLianghao: {
    type: "post",
    url: config.managerHost + "/api/pretty/phone/update",
    ContentType: "application/json"
  },
  // 靓号管理》靓号管理 - 删除
  delLianghao: {
    type: "post",
    url: config.managerHost + "/api/pretty/phone/delete",
    ContentType: "application/json"
  },
  // 靓号管理》靓号管理 - 导入
  importlLianghao: {
    type: "post",
    url: config.managerHost + "/api/pretty/phone/import",
    ContentType: "multipart/form-data"
  },
  // 靓号管理》已购买靓号管理 - 查询
  getPurchasedLianghaoList: {
    type: "post",
    url: config.managerHost + "/api/pretty/buy/page",
    ContentType: "application/json"
  },
  // 订单管理》靓号订单列表 - 查询
  getLianghaoOrderList: {
    type: "post",
    url: config.managerHost + "/api/pretty/order/page",
    ContentType: "application/json"
  },
  // 订单管理》会员订单管理 - 查询
  getMemberOrderList: {
    type: "post",
    url: config.managerHost + "/api/privilege/vip-order/page",
    ContentType: "application/json"
  },
  // 会员管理》会员特权 - 查询
  getMembershipList: {
    type: "post",
    url: config.managerHost + "/api/privilege/page",
    ContentType: "application/json"
  },
  // 会员管理》会员特权 - 添加
  addMembership: {
    type: "post",
    url: config.managerHost + "/api/privilege/create",
    ContentType: "application/json"
  },
  // 会员管理》会员特权 - 修改
  updMembership: {
    type: "post",
    url: config.managerHost + "/api/privilege/update",
    ContentType: "application/json"
  },
  // 钱包管理》黑名单管理 - 查询
  getIdentityBlackList: {
    type: "post",
    url: config.managerHost + "/api/blacklist/page",
    ContentType: "application/json"
  },
  // 钱包管理》黑名单管理 - 添加
  addIdentityBlack: {
    type: "post",
    url: config.managerHost + "/api/blacklist/create",
    ContentType: "application/json"
  },
  // 钱包管理》黑名单管理 - 移除
  delIdentityBlack: {
    type: "post",
    url: config.managerHost + "/api/blacklist/delete",
    ContentType: "application/json"
  },
  // 钱包管理》账单管理 - 查询
  getBillList: {
    type: "post",
    url: config.managerHost + "/api/bills/page",
    ContentType: "application/json"
  },
  //钱包管理》账单管理 - 导出
  exportBill: {
    type: "post",
    url: config.managerHost + "/api/bills/export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 钱包管理》提现管理 - 查询
  getWithdrawalList: {
    type: "post",
    url: config.managerHost + "/api/withdraws/page",
    ContentType: "application/json"
  },
  //钱包管理》提现管理 - 导出
  exportWithdrawal: {
    type: "post",
    url: config.managerHost + "/api/withdraws/export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 钱包管理》提现管理 - 提现标记
  withdrawalSign: {
    type: "post",
    url: config.managerHost + "/api/withdraws/sign",
    ContentType: "application/json"
  },
  // 钱包管理》提现管理 - 批量代发
  batchIssuing: {
    type: "post",
    url: config.managerHost + "/api/withdraws/batch-pay",
    ContentType: "application/json"
  },
  // 钱包管理》银行卡管理 - 列表
  getBankList: {
    type: "post",
    url: config.managerHost + "/api/banks/page",
    ContentType: "application/json"
  },
  // 钱包管理》转账红包管理 - 列表
  getRedpackageList: {
    type: "post",
    url: config.managerHost + "/api/gifts/page",
    ContentType: "application/json"
  },
  // 钱包管理》转账红包管理 - 退款
  getRedconmeback: {
    type: "post",
    url: config.managerHost + "/api/gifts/refund",
    ContentType: "application/json"
  },
  // 钱包管理》转账红包管理 - 强制退款
  getRedconmebackqz: {
    type: "post",
    url: config.managerHost + "/api/gifts/refund-force",
    ContentType: "application/json"
  },
  // 钱包管理》转账红包管理 - 统计
  getRedpackageTotalList: {
    type: "post",
    url: config.managerHost + "/api/gifts/sum",
    ContentType: "application/json"
  },
  // 钱包管理》退款列表
  getcomemoneyTotalList: {
    type: "post",
    url: config.managerHost + "/api/gifts/refunds/page",
    ContentType: "application/json"
  },

  //商户对账单----查询
  BillSearch: {
    type: "post",
    url: config.managerHost + "/api/company/bills/page",
    ContentType: "application/json"
  },
  // 商户对账单----导出
  BILLexport: {
    type: "post",
    url: config.managerHost + "/api/company/bills/export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 分账流水账单----查询
  MerchantSearch: {
    type: "post",
    url: config.managerHost + "/api/company/splits/page",
    ContentType: "application/json"
  },
  // 分账流水账单----导出
  Merchantexport: {
    type: "post",
    url: config.managerHost + "/api/company/splits/export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 商户列表
  REGISTERlist: {
    type: "post",
    url: config.managerHost + "/api/company/register/info",
    ContentType: "application/json"
  },
  // 审核
  REGISTERsh: {
    type: "post",
    url: config.managerHost + "/api/company/register/review",
    ContentType: "application/json"
  },
  // 审核进度
  REGISTERtimeline: {
    type: "post",
    url: config.managerHost + "/api/company/register/progress",
    ContentType: "application/json"
  },
  // 查看费率
  checkREGISTER: {
    type: "post",
    url: config.managerHost + "/api/company/fee/get",
    ContentType: "application/json"
  },
  // 修改费率
  editREGISTER: {
    type: "post",
    url: config.managerHost + "/api/company/fee/update",
    ContentType: "application/json"
  },
  // 获取图片信息
  preview: {
    type: "post",
    url: config.managerHost + "/api/company/register/pics",
    ContentType: "application/json"
  },
  // 商户交易记录
  COMPANYlist: {
    type: "post",
    url: config.managerHost + "/api/company/orders/page",
    ContentType: "application/json"
  },
  // 用户交易记录
  USERCOMPANYlist: {
    type: "post",
    url: config.managerHost + "/api/invoices/page",
    ContentType: "application/json"
  },
  // 用户交易记录 导出
  USERCOMPANYexport: {
    type: "post",
    url: config.managerHost + "/api/invoices/export",
    ContentType: "application/json",
    responseType: "blob"
  },
  // 商户管理--列表
  REGISTERUSERlist: {
    type: "post",
    url: config.managerHost + "/api/company/merchants/page",
    ContentType: "application/json"
  },

  // 风险消息列表
  risklist: {
    type: "post",
    url: config.managerHost + "/api/messages/sensitive/page",
    ContentType: "application/json"
  },
  // 公告文章
  // 新增
  addnotice: {
    type: "post",
    url: config.managerHost + "/api/notices/create",
    ContentType: "application/json"
  },
  // 列表
  noticelist: {
    type: "post",
    url: config.managerHost + "/api/notices/page",
    ContentType: "application/json"
  },
  //删除
  noticedel: {
    type: "post",
    url: config.managerHost + "/api/notices/delete",
    ContentType: "application/json"
  },
  // 商户管理----提现记录
  WITHDRAWlist: {
    type: "post",
    url: config.managerHost + "/api/company/withdraws/page",
    ContentType: "application/json"
  },
  // 交易冻结
  WALLETPACKETDELAYLIST: {
    type: "post",
    url: config.managerHost + "/api/gifts/delay/page",
    ContentType: "application/json"
  },
  // 在线客服 - 工作台初始化
  csDeskInit: {
    type: "post",
    url: config.managerHost + "/api/cs/init",
    ContentType: "application/json"
  },
  // 在线客服 - 会话列表
  csSessionList: {
    type: "post",
    url: config.managerHost + "/api/cs/sessions/page",
    ContentType: "application/json"
  },
  // 在线客服 - 接单
  csSessionAccept: {
    type: "post",
    url: config.managerHost + "/api/cs/accept",
    ContentType: "application/json"
  },
  // 在线客服 - 转接
  csSessionTransfer: {
    type: "post",
    url: config.managerHost + "/api/cs/transfer",
    ContentType: "application/json"
  },
  // 在线客服 - 结束会话
  csSessionClose: {
    type: "post",
    url: config.managerHost + "/api/cs/close",
    ContentType: "application/json"
  },
  // 在线客服 - 在线状态
  csAgentStatus: {
    type: "post",
    url: config.managerHost + "/api/cs/agent-status",
    ContentType: "application/json"
  },
  // 在线客服 - 会话消息
  csMessageList: {
    type: "post",
    url: config.managerHost + "/api/cs/messages",
    ContentType: "application/json"
  },
  // 在线客服 - 渠道列表
  csChannelList: {
    type: "post",
    url: config.managerHost + "/api/cs/channels/page",
    ContentType: "application/json"
  },
  // 在线客服 - 渠道保存
  csChannelSave: {
    type: "post",
    url: config.managerHost + "/api/cs/channels/save",
    ContentType: "application/json"
  },
  // 在线客服 - 坐席列表
  csAgentList: {
    type: "post",
    url: config.managerHost + "/api/cs/agents/page",
    ContentType: "application/json"
  },
  // 在线客服 - 坐席保存
  csAgentSave: {
    type: "post",
    url: config.managerHost + "/api/cs/agents/save",
    ContentType: "application/json"
  },
  // 在线客服 - 会话记录
  csSessionHistory: {
    type: "post",
    url: config.managerHost + "/api/cs/sessions/history",
    ContentType: "application/json"
  },
  // 在线客服 - 生成 App 进线链接
  csEntryUrl: {
    type: "post",
    url: config.managerHost + "/api/cs/entry-url",
    ContentType: "application/json"
  }
};
// 超时时间
// axios.defaults.timeout = 20000
// http请求拦截器
var loadinginstace;
axios.interceptors.request.use(
  config => {
    if (!config.silentLoading) {
      loadinginstace = Loading.service({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      });
    }
    return config;
  },
  error => {
    if (loadinginstace) {
      loadinginstace.close();
    }
    Message({
      message: "加载超时",
      type: "error"
    });
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  response => {
    //响应成功关闭loading
    console.log("响应", response);
    if (!response.config.silentLoading && loadinginstace) {
      loadinginstace.close();
    }
    if (response.config.responseType != "blob") {
      response.data = normalizeBiz(response.data);
      const code = bizCode(response.data);
      if (
        response.status != "200" ||
        (response.status == "200" &&
          code != "001" &&
          code != "000")
      ) {
        Message({
          message: bizMsg(response.data),
          type: "error",
          callback: action => {
          }
        });
      }
      if (response.config.responseType != "blob") {
        if (response.status == "200" && code == "001") {
          Message({
            message: bizMsg(response.data),
            type: "error",
            callback: action => {
            }
          });

          // 重新登录
          setTimeout(() => {
            window.location.href =
              window.location.origin + window.location.pathname;
          }, 100);
        }
      }
    }
    return response;
  },
  error => {
    if (!error.config || !error.config.silentLoading) {
      if (loadinginstace) {
        loadinginstace.close();
      }
      Message({
        message: "请求失败",
        type: "error"
      });
    }
    return Promise.reject(error);
  }
);

let api = {};
Object.keys(apiUrl).forEach(item => {
  /*** 创建api请求function，返回promise对象*/
  api[item] = function apiFunc(data, options) {
    let obj = apiUrl[item];
    const opts = options || {};
    const silentLoading = !!opts.silentLoading;
    let promise;
    promise = axios({
      method: obj.type,
      url: obj.url,
      timeout: 120000,
      silentLoading,
      data:
        obj.ContentType == "multipart/form-data"
          ? data
          : obj.url.indexOf(config.managerHost) === 0
          ? data
          : {
            HEAD: {
              TOKEN: localStorage.getItem("kposToken")
                ? localStorage.getItem("kposToken")
                : ""
            },
            BODY: data
          },
      // data:{HEAD:{TOKEN:localStorage.getItem('kposToken')},BODY:data},
      headers: {
        "Content-Type": obj.ContentType,
        token: localStorage.getItem("kposToken")
      },
      responseType: obj.responseType
    })
      .then(response => {
        let data = response;
        return data;
      })
      .catch(error => {
        Message({
          message: error,
          type: "error"
        });
        console.error(error);
      });
    return promise;
  };
});
api.oaHost = config.oaHost;
api.managerHost = config.managerHost;
api.H5Host = config.H5Host;
export default api;



// WEBPACK FOOTER //
// ./src/oos/api/index.js